export default {
  path: '/nao-autorizado',
  name: 'NotAuthorized',
  component: () => import(/* webpackChunkName: "Dashboard" */ '@core/layout/NotAuthorized.vue'),
  meta: { subject: 'Auth', action: 'read' },
}
